const en = {
  header: {
    about: 'About',
    contact: 'Contact',
    sign_in: 'Sign in',
    dashboard: 'Dashboard',
    biolink_page: 'Biolink Page',
    admin: 'Admin',
    logout: 'Logout',
    sign_up: 'Sign up',
    about_us: 'About Us',
    contact_us: 'Contact Us',
    payments_list: 'Payments list',
  },

  biolink_title: {
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    settings: 'Settings',
    duplicate: 'Duplicate',
    your_link_is: 'Your link is',
    copy_to_clipboard: 'Copy To Clipboard',
    copied: 'Copied',
    change_status: 'Change Status',
    edit_user: 'Edit user',
    block: 'Block',
    november: 'November',
  },

  contact: {
    name_required: 'Name is required',
    only_alphabets: 'Only alphabets are allowed for this field ',
    more_characters: 'Name cant more than 20 characters.',
    valid: 'Email must be a valid',
    subject: 'Subject is required',
    subject_max: 'Subject cant more than 30 characters.',
    message: 'Message is required',
    message_min: 'Minimum Message Must be 40 characters long.',
    message_max: 'Message Cant more than 250 characters.',
  },

  descriptions: {
    fully_featured: 'Fully featured QR code generator system with easy to use templates.',
    update_checkout: 'Update & continue to Golden checkout',
    plans_management: 'Plans Management',
    create_plan: 'Create Plan',
    no_account: 'Dont have an account?',
    leave_empty: 'Leave empty for a random generated one.',
    scan_qr:
      'If you want to activate two factor authentication scan the QR Code or enter the secret key in Google Authenticator App and enter OTP',
    skip: 'Or skip',
    copy_Qr: 'Copy the secret key it is confidential',
    scanned: 'Check your email OR  Google Authenticator for code. ',
    do_everything: 'Do everything',
    with_one: 'with one',
    platform: 'platform',
    shorten_urls: 'Shorten URLs, create bio link pages, custom QR codes, vcard links, file links & more.',
    get_started: 'GET STARTED',
    create_own: 'Create your own unique & highly customizable bio link page with ease.',
    custom_colors: 'Custom colors & branding',
    ready_to_use: 'Multiple ready-to-use components',
    protection: 'Password protection, sensitive content warning',
    seo_setting: 'SEO Settings',
    shortened_links: 'Shortened Links',
    service: 'Yes! You can use our service as a shortener as well.',
    demographic: 'Country, device & language targeting',
    scheduling: 'Scheduling & expiration limits',
    ab_rotation: 'A/B Rotation',
    password: 'Password protection, sensitive content warning',
    built_in: 'Built-in analytics',
    generate_links:
      'Generate dynamic links to files and benefit from tracking, protection, pixels & expiration features.',
    generate_vcard:
      'Generate dynamic vcard links to your contact downloadable card and benefit from tracking, protection, pixels & expiration features.',
    day_by: 'For daily analytics, referrals, countries, operating systems, languages ​​and many more.',
    connect: 'Connect your own domain or use our predefined ones.',
    easiest_way: 'Easiest way to categorize your managed resources.',
    offering: 'We also give you a set of 35 useful web tools as a bonus.',
    choose_yourself: 'Choose and get exactly what you need.',
    feel_free: 'Feel free to contact us',
    enter_message: 'Enter your message here.',
    add_multiple_images: 'Add Multiple Images',
    add_link: 'Add a Link Button',
    add_new: 'Add a new block',
    add_heading: 'Add a Heading',
    add_avatar: 'Add a Avatar',
    add_social: 'Add social links',
    choose_custom_plan: 'Start the Golden Plan',
    almost_there: 'You are almost there, no strings attached.',
    trial_start: 'Start my 7 Days Trial',
    skip_trial: 'Skip Trial',
    trial_info: 'By continuing with your order you confirm that you read, understand & agree to the  of the site.',
    terms: 'Terms and Conditions',
    add_image: 'Add an Image',
    img_description: 'Image description for accessibility & SEO purposes.',
    add_youtube: 'Add a YouTube video',
    paste_video_url: 'Paste in your YouTube video URL and we will show it as a video on your profile.',
    add_tiktok: 'Add a TikTok video',
    tiktok_url: 'TikTok Video URL',
    valid_email: 'Email must be a valid email address',
    distination_Url: 'distination_url',
    email_required: 'Email is required',
    password_required: 'Password is required',
    name_required: 'Name is required',
    user_name_required: 'User name is required',
    firstName_required: 'First name is required',
    enter_email:
      'Please enter the email address associated with your account and We will email you a link to reset your password.',
    already_account: 'Already have an account?',
    paste_tiktok: 'Share your TikTok video url',

    drag_drop: 'Drag & Drop to Reorder',
    can_confirm: 'I confirm that I have read and understood the',
    of_site: 'of the site.',
    confirm_password: 'Confirm New Password',
    confirm_new: 'Confirm password is required',
    field_required: 'Field Required',
    add_instagram: 'Add an Instagram Post',
    entered_url: 'Your entered URL is invalid for embedding',
    least_characters: 'Password must be at least 6 characters',
    must_match: 'Passwords must match',
    check_email: 'Please check your email!',
    sent_code:
      'We have emailed a 6-digit confirmation code to acb@domain, please enter the code in below box to verify your email.',
    no_code: 'Dont have a code?',
    code_required: 'Code is required',
    checking_email: 'Checking user Email',
    monthly_payment: 'Monthly payment',
    golden_plan: 'Golden plan',
    plan_detail: 'You are almost there, complete the following form and checkout.',
    payment_frequency: 'Payment frequency',
    annual_payments: 'Annual Payments',
    lifetime_deal: 'Lifetime deal',
    payment_method: 'Payment method',
    payment_method_stripe: 'Payment by Stripe',
    type_payment: 'Type of payment',
    stripe: 'Stripe',
    one_payment: 'One Time Payment',
    recurring_payment: 'Recurring Payment',
    order_summary: 'Order summary',
    plan: 'Plan',
    golden: 'Golden',
    frequency: 'Frequency',
    monthly: 'Monthly',
    type: 'Type',
    one_time: 'One time',
    paid_with: 'Paid with',
    pay_pal: 'PayPal',
    price: 'Price',
    code_redeemable: 'I have a discount/redeemable code',
    code: 'Code',
    total: 'Total',
    checkout: 'Checkout',
    day: 'Every 30 days',
    billing: 'Billing',
    choosen_plan: 'Choosen Plan',
    home: 'Home',
    what_get: "What you'll get",
    one_product: 'One end products',
    month_update: '12 months updates',
    month_support: '6 months of support',
    bio_pages: '25 Biolink Pages',
    bio_block: '10 Biolink Blocks',
    all_block: 'All Biolink Blocks',
    short_link: '250 Shortened Links',
    file_link: '2 File Links',
    vcard_link: '2 Vcard Links',
    qr_code: '5 QR Codes',
    proj: '50 Projects',
    pixel: '5 Pixels',
    custom_domain: 'Custom Domains',
    day_stat: '365 days statistics retention',
    global_domain: 'Additional Global Domains ',
    back_half: 'Custom Back-half',
    deep_lnk: 'Deep linking',
    removable_brand: 'Removable branding',
    custom_back: 'Custom Backgrounds',
    custom_col: 'Custom colors',
    defollow: 'Dofollow links',
    leap_link: 'Leap link',
    seo_feature: 'SEO Features',
    extra_font: 'Extra fonts',
    add_tweet: 'Add a Tweet',
    custome_css: 'Custom CSS',
    custom_js: 'Custom JS',
    no_ad: 'No ads',
    api_access: 'Api access',
    fill: 'Fill in your billing details',
    handling:
      'We require your billing details for generating proper invoices & for tax handling, provide valid billing details only.',
    user_manag: 'User Management',
    user_logs: ' Users logs',
    user_creat: 'Create User',
    set_2fa: 'Setup 2-Factor Authentication',
    user: 'User',
    showout_result: 'Showing Results',
    status: 'Status',
    applied_codes: 'Applied Codes',
    applied_taxes: 'Applied Taxes',
    detail: 'Details',
    bulk_actions: 'Bulk Actions',
    hidden_demo: 'hidden on demo',
    cant_undone: ' cannot be undone.',
    login_thisuser: 'Login as this user',
    loginmodal_detail1: 'By logging in as another user, you will be logged out of the',
    loginmodal_detail2: 'current account and fully logged in to this user.',
    show_result: 'Showing 1-12 out of 12 results.',
    total_sales: 'Total Sales',
    visitors: 'Visitors',
    page_views: 'PageViews',
    paste_instagram_url: 'Paste URL of an Instagram post',
    delete_block_des: 'All data related to the biolink block will be completely deleted. This action cannot be undone.',
    duplicate_block_des: 'Easily duplicate this resource with a click of a button.',
    delete_block: 'Delete block',
    duplicate_block: 'Duplicate block',
    total_amount: 'Total Amount',
    admin_privileges: 'Admin users will have the same privileges as you, be careful!',
    change_passDetail: "Leave it empty if you don't want to change the user's password!",
    new_pass: 'New password',
    repeat_pass: 'Repeat Password',
    block_search: 'Block Search Engine Indexing',
    block_biolink: 'Block your biolink page from being indexed by search engines.',
    change_page: 'Completely change the page title to a custom one that you are setting here.',
    custom_meta: 'Set a custom meta description for your biolink page to rank better in search engines.',
  },

  admin: {
    welcome: 'Welcome Back',
    biolink_pages: 'Biolink Pages',
    pageviews_tracked: 'Pageviews tracked',
  },

  label: {
    view_user: 'View User',
    privileges: 'Privileges',
    timezone: 'Timezone',
    Factor_authentication: 'Two Factor authentication',
    Anti_code: 'Anti pishing code',
    active: 'Active',
    english: 'English',
    no: 'No',
    api_key: 'API Key',
    total_logins: 'Total logins',
    last_useragent: 'Last user agent',
    last_active: 'Last Active',
    country: 'Country',
    direct_signup: 'Direct sign up',
    source: 'Source',
    trial_done: 'Trial is done',
    last_subid: 'Last subcription id',
    last_payamount: 'Last payment amount',
    last_payprocessor: 'Last payment processor',
    plan_expdate: 'Plan expiration date',
    free: 'Free',
    disabled: 'Disabled',
    hidden: 'Hidden',
    arabic: 'Arabic',
    main_language: ' Main language',
    add_tweet: 'Add a Tweet',
    update: 'Update',
    change_password: 'Change Password',
    enable_stripepay: 'Enable Stripe payments',
    publishable_key: 'Publishable Key',
    secret_key: 'Secret Key',
    webhook_secret: 'Webhook Secret',
    webhook: 'Webhook',
    more_detail: ' to get more details on certain available configurations.',
    read_the: 'Read the',
    documentation: 'Documentation',
  },

  payments: 'Payments',
  terms_here: 'Your terms of service go here',
  bold: 'Bold',
  user_id: 'User ID',
  italic: 'Italic',
  underline: 'Underline',
  changelog_config: '  Make sure to re-configure your plans settings for the new additional domains configuration',
  initial_release: 'Initial release',
  changelog_detail:
    'All of the updates for Bil Bio will be listed here. Bil Bio versioning is based on the MAJOR.MINOR.PATCH system',
  get_support: 'Get Support',
  support_is: 'Support is ',
  only: 'only',
  done_codecanyon: "done through Codecanyon's",
  email_form: 'email form',
  comments: 'comments',
  section: 'section',
  changelog: 'Changelog',
  edit_home: 'Edit Home',
  home_settings: 'Home Settings',
  docs: 'Docs',
  read_documentation: 'Read Documentation',
  read_changelog: 'Read Changelog',
  latest_users: 'Latest Users',
  page_views: 'Page Views',
  biolinks_pages: 'Biolinks Pages',
  authenticate: 'Authenticate',
  auth_type: 'Auth Type ',
  time_based: 'Time Based ',
  secret_key: 'Secret Key',
  availabe_plan: 'How many days will the plan be available for',
  code_usage: 'How many time the code can be used',
  percent_disc: 'Percentage discount',
  fix_discount: 'Fixed amount discount',
  discount_amount: 'Discount Amount',
  percent_amount: 'Percentage amount',
  duration: 'Duration',
  once: 'once',
  forever: 'forever',
  repeating: 'repeating',
  number_ofmonths: 'Number of months',
  months: 'months',
  currency: 'Currency',
  redeemable: 'Redeemable',
  install_product: 'How to install the product?',
  update_product: 'How to update the product? ',
  customize_product: 'How to customize the product?',
  meta_description: 'Meta Description',
  title: 'Title',
  statistics: 'Statistics',
  opengraph_image: 'OpenGraph Image',
  page_title: 'Page Title',
  countdown: 'Countdown',
  personal: 'Personal',
  business: 'Business',
  city: 'City',
  country: 'Country',
  province: 'Province',
  zip: 'Zip',
  resend_code: 'Resend Code',
  yes: 'Yes',
  choose_plan: 'Choose Plan',
  home: 'Home',
  social: 'Social',
  whatYouWillGet: "What you'll get",
  and: 'and',
  links_statistics: 'Links Statistics',
  oftheSite: 'of the site',
  link: 'Link',
  telephone: 'Telephone',
  register: 'Register',
  facebook: 'Facebook',
  google: 'Google',
  tracking_pixels: 'Tracking Pixels',
  tool: 'Tool',
  block: 'Block',
  instagram: 'Instagram',
  twitter: 'Twitter',
  username: 'Username',
  add: 'Add',
  short_url: 'Short URL',
  customization: 'Customization',
  channel: 'Channel',
  branding: 'Branding',
  fonts: 'Fonts',
  submit: 'Submit',
  tracked_reviews: 'Tracked pageviews',
  delete: 'Delete',
  duplicate: 'Duplicate',
  monochrome: 'Monochrome',
  gradient: 'Gradient',
  custom: 'Custom',
  themes: 'Themes',
  background: 'Background',
  simple_gradients: 'Simple Gradients',
  abstract_gradients: 'Abstract Gradients',
  custom_color: 'Custom Color',
  faq: 'FAQ',
  color: 'Color',
  custom_image_video: 'Custom Image/Video',
  favicon: 'Favicon',
  share: 'Share',
  image_alt: 'Image Alt',
  maximum: '.png, .gif, .ico, allowed. 2 MB maximum.',
  display: 'Display',
  total_earned: 'Total Earned',
  name: 'Name',
  Unique_user_name: 'Unique user name',
  firstName: 'First Name',
  text_color: 'Text Color',
  default_branding: 'Leave empty to have the default site branding.',
  size: 'Size',
  instagram_url: 'Instagram Post URL',
  border_radius: 'Border Radius',
  youtube_url: 'YouTube Video URL',
  total: 'Total',
  biolinks: 'Biolinks',
  biolink: 'Biolink',
  files: 'Files',
  file: 'File',
  biolink_blocks: 'Biolink Blocks',
  card: 'Card',
  destination_url: 'Destination URL',
  codes: 'Codes',
  domains: 'Domains',
  create: 'Create Tax',
  links: 'Links',
  copyright: 'Copyright',
  terms_of_service: 'Terms of Service',
  views: 'views',
  privacy_policy: 'Privacy Policy',
  overview: 'Overview',
  needed_docs: 'In this page you can find the needed documentation for you to fully install and configure the product',
  product_installation:
    ' The product installation procedure is straight forward and does not require any special / out of the ordinary task Minimum knowledge on how to work with a database and managing files on a server is required',
  policy_here: 'Your Privacy Policy go here',
  requirements: 'Requirements',
  meet_req:
    ' Please make sure your server meets the following requirements before attempting to install or purchase the product.',
  created_on: 'Created on ',
  extensions: 'Extensions',
  database: 'Database',
  server: 'Server',
  other_extentions:
    '  Keep in mind, other extensions others than those mentioned here might be required, as these requirements assume you run on a decent, up-to-date server that should have the basic required extensions already working.',
  find_me: "I build High quality, ready to use & affordable software. Here's where you can find me:",
  december: 'December',
  twitter_bilBio: 'Twitter @BilBio',
  official_website: 'Official website',
  who_are_we: 'Who are we?',
  all_rights_reserved: 'All rights Reserved',
  export_to: 'Export to',
  filter: 'Filter',
  search: 'Search',
  search_by: 'Search by',
  status: 'Status',
  project: 'Project',
  type: 'Type',
  order_type: 'Order Type',
  results_per_page: 'Results per Page',
  your_custom_alias: 'your-custom-alias',
  mode: 'Mode',
  contrast: 'Contrast',
  direction: 'Direction',
  layout: 'Layout',
  presets: 'Presets',
  stretch: 'Stretch',
  fullscreen: 'Fullscreen',
  exit: 'Exit',
  pricing_plans: 'Pricing plans',
  monthly: 'Monthly',
  annual: 'Annual',
  life_time: 'Lifetime',
  address: 'Address',
  phone: 'Phone',
  send_message: 'Send Message',
  email: 'Email',
  subject: 'Subject',
  heading: 'Heading',
  avatar: 'Avatar',
  socials: 'Socials',
  linkedin: 'LinkedIn',
  snapchat: 'SnapChat',
  twitch: 'Twitch',
  spotify: 'Spotify',
  image: 'Image',
  pinterest: 'Pinterest',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  about_section: 'About Section Settings',
  contact_settings: 'Contact Settings',
  Biolink_Page: 'Biolink Page',
  Qr_code: 'QR Codes',
  analytics: 'Built-in analytics', 
  destination: 'Destination',
  purchased_Plan_monthly: 'You have purchased a monthly Plan.',
  purchased_Plan_yearly: 'You have purchased a annually Plan.',
  purchased_Plan_lifetime: 'You have purchased a lifetime Plan',
  enjoy_your_plan: 'Please enjoy your lifetime plan.',
  close: 'Close',
  want_to_update_plan_yearly_lifetime: 'Do you want to update your plan Annually or LifeTime?',
  want_to_update_plan_lifetime: 'Do you want to update your plan LifeTime?',
  updating_plan: 'Updating Plan',
  powered_by: 'Powered by',
  text: 'Text',
  round: 'Round',
  rounded: 'Rounded',
  straight: 'Straight',
  solid: 'Solid',
  dashed: 'Dashed',
  double: 'Double',
  outset: 'outset',
  inset: 'Inset',
  border_width: 'Border Width',
  border_color: 'Border Color',
  border_style: 'Border Style',
  infinite: 'Infinite',
  bg_color: 'Background Color',
  animation: 'Animation',
  animation_runs: 'Animation Runs',
  bounce: 'Bounce',
  tada: 'Tada',
  wobble: 'Wobble',
  swing: 'Swing',
  rubberband: 'Rubberband',
  pulse: 'Pulse',
  flash: 'Flash',
  bounce_in: 'BounceIn',
  fade_in: 'FadeIn',
  small: 'Small',
  medium: 'Medium',
  large: 'Large',
  img_thumbnail: 'Image Thumbnail',
  email_address: 'Email Address',
  pass: 'Password',
  forgot_password: 'Forgot Password?',
  login: 'Login',
  remember_me: 'Remember me',
  send_request: 'Send Request',
  back: 'Back',
  dashboard: 'Dashboard',
  plans: 'Plans',
  taxes: 'Taxes',
  website_settings: 'Website Settings',
  languages: 'Languages',
  language_code: 'Language code',
  verify: 'Verify',
  tweet_id: 'Tweet ID',
  divider: 'Divider',
  add_divider: 'Add Divider',
  seo: 'SEO',
  image_grid: 'Image Grid',
  codes_management: ' Codes Management',
  create_tax: 'Create Tax',
  redeemed: 'Redeemed',
  quantity: 'Quantity',
  discount: 'Discount',
  tax: 'Tax',
  billing_for: 'Billing for',
  taxes_management: 'Taxes management',
  random_discription: 'A random description for a support fee.',
  personal_business: 'Personal & Business',
  exclusive: 'Exclusive',
  support_fee: 'Support Fee',
  call_to_action: 'Call to Action',
  language: 'Language',
  users: 'Users',
  add_plan: 'Add Plan',
  interval_count: 'Interval Count',
  interval: 'Interval',
  trial_days: 'Trial Days',
  year: 'year',
  month: 'month',

  countries: {
    afghanistan: '🇦🇫 Afghanistan',
    aland_islands: '🇦🇽 Aland Islands',
    albania: '🇦🇱 Albania',
    algeria: '🇩🇿 Algeria',
    american_samoa: '🇦🇸 American Samoa',
    andorra: '🇦🇩 Andorra',
    angola: '🇦🇴 Angola',
    anguilla: '🇦🇮 Anguilla',
    antarctica: '🇦🇶 Antarctica',
    antigua_barbuda: '🇦🇬 Antigua and Barbuda',
    argentina: '🇦🇷 Argentina',
    armenia: '🇦🇲 Armenia',
    aruba: '🇦🇼 Aruba',
    australia: '🇦🇺 Australia',
    austria: '🇦🇹 Austria',
    azerbaijan: '🇦🇿 Azerbaijan',
    bahamas: '🇧🇸 Bahamas',
    bahrain: '🇧🇭 Bahrain',
    bangladesh: '🇧🇩 Bangladesh',
    barbados: '🇧🇧 Barbados',
    belarus: '🇧🇾 Belarus',
    belgium: '🇧🇪 Belgium',
    belize: '🇧🇿 Belize',
    benin: '🇧🇯 Benin',
    bermuda: '🇧🇲 Bermuda',
    bhutan: '🇧🇹 Bhutan',
    bolivia: '🇧🇴 Bolivia',
    eustatius_saba: '🇧🇶 Bonaire, Sint Eustatius and Saba',
    bosnia_herzegovina: '🇧🇦 Bosnia and Herzegovina',
    botswana: '🇧🇼 Botswana',
    bouvet_island: '🇧🇻 Bouvet Island',
    brazil: '🇧🇷 Brazil',
    british_indian: '🇮🇴 British Indian Ocean Territory',
    brunei_darussalam: '🇧🇳 Brunei Darussalam',
    bulgaria: '🇧🇬 Bulgaria',
    burkina_faso: '🇧🇫 Burkina Faso',
    burundi: '🇧🇮 Burundi',
    cambodia: '🇰🇭 Cambodia',
    cameroon: '🇨🇲 Cameroon',
    canada: '🇨🇦 Canada',
    cape_verde: '🇨🇻 Cape Verde',
    cayman_islands: '🇰🇾 Cayman Islands',
    central_african: '🇨🇫 Central African Republic',
    chad: '🇹🇩 Chad',
    chile: '🇨🇱 Chile',
    china: '🇨🇳 China',
    christmas_island: '🇨🇽 Christmas Island',
    cocos_islands: '🇨🇨 Cocos (Keeling) Islands',
    colombia: '🇨🇴 Colombia',
    comoros: '🇰🇲 Comoros',
    congo: '🇨🇬 Congo',
    democratic_republic: '🇨🇩 Congo, Democratic Republic of the Congo',
    cook_islands: '🇨🇰 Cook Islands',
    costa_rica: '🇨🇷 Costa Rica',
    cote_ivoire: '🇨🇮 Cote D Ivoire',
    croatia: '🇭🇷 Croatia',
    cuba: '🇨🇺 Cuba',
    curacao: '🇨🇼 Curacao',
    cyprus: '🇨🇾 Cyprus',
    czech_republic: '🇨🇿 Czech Republic',
    denmark: '🇩🇰 Denmark',
    djibouti: '🇩🇯 Djibouti',
    dominica: '🇩🇲 Dominica',
    dominican_republic: '🇩🇴 Dominican Republic',
    ecuador: '🇪🇨 Ecuador',
    egypt: '🇪🇬 Egypt',
    el_salvador: '🇸🇻 El Salvador',
    equatorial_guinea: '🇬🇶 Equatorial Guinea',
    eritrea: '🇪🇷 Eritrea',
    estonia: '🇪🇪 Estonia',
    ethiopia: '🇪🇹 Ethiopia',
    falkland_islands: '🇫🇰 Falkland Islands (Malvinas)',
    faroe_islands: '🇫🇴 Faroe Islands',
    fiji: '🇫🇯 Fiji',
    finland: '🇫🇮 Finland',
    france: '🇫🇷 France',
    french_guiana: '🇬🇫 French Guiana',
    french_polynesia: '🇵🇫 French Polynesia',
    southern_territories: '🇹🇫 French Southern Territories',
    gabon: '🇬🇦 Gabon',
    gambia: '🇬🇲 Gambia',
    georgia: '🇬🇪 Georgia',
    germany: '🇩🇪 Germany',
    ghana: '🇬🇭 Ghana',
    gibraltar: '🇬🇮 Gibraltar',
    greece: '🇬🇷 Greece',
    greenland: '🇬🇱 Greenland',
    grenada: '🇬🇩 Grenada',
    guadeloupe: '🇬🇵 Guadeloupe',
    guam: '🇬🇺 Guam',
    guatemala: '🇬🇹 Guatemala',
    guernsey: '🇬🇬 Guernsey',
    guinea: '🇬🇳 Guinea',
    guinea_bissau: '🇬🇼 Guinea-Bissau',
    guyana: '🇬🇾 Guyana',
    haiti: '🇭🇹 Haiti',
    heard_island: '🇭🇲 Heard Island and Mcdonald Islands',
    holy_see: '🇻🇦 Holy See (Vatican City State)',
    honduras: '🇭🇳 Honduras',
    hong_kong: '🇭🇰 Hong Kong',
    hungary: '🇭🇺 Hungary',
    iceland: '🇮🇸 Iceland',
    india: '🇮🇳 India',
    indonesia: '🇮🇩 Indonesia',
    iran_islamic: '🇮🇷 Iran, Islamic Republic of',
    iraq: '🇮🇶 Iraq',
    ireland: '🇮🇪 Ireland',
    isle_man: '🇮🇲 Isle of Man',
    israel: '🇮🇱 Israel',
    italy: '🇮🇹 Italy',
    jamaica: '🇯🇲 Jamaica',
    japan: '🇯🇵 Japan',
    jersey: '🇯🇪 Jersey',
    jordan: '🇯🇴 Jordan',
    kazakhstan: '🇰🇿 Kazakhstan',
    kenya: '🇰🇪 Kenya',
    kiribati: '🇰🇮 Kiribati',
    korea_democratic: '🇰🇵 Korea, Democratic Peoples Republic of',
    korea_republic: '🇰🇷 Korea, Republic of',
    kosovo: '🇽🇰 Kosovo',
    kuwait: '🇰🇼 Kuwait',
    kyrgyzstan: '🇰🇬 Kyrgyzstan',
    lao_people: '🇱🇦 Lao Peoples Democratic Republic',
    latvia: '🇱🇻 Latvia',
    lebanon: '🇱🇧 Lebanon',
    lesotho: '🇱🇸 Lesotho',
    liberia: '🇱🇷 Liberia',
    libyan_arab: '🇱🇾 Libyan Arab Jamahiriya',
    liechtenstein: '🇱🇮 Liechtenstein',
    lithuania: '🇱🇹 Lithuania',
    luxembourg: '🇱🇺 Luxembourg',
    macao: '🇲🇴 Macao',
    macedonia_former: '🇲🇰 Macedonia, the Former Yugoslav Republic of',
    madagascar: '🇲🇬 Madagascar',
    malawi: '🇲🇼 Malawi',
    malaysia: '🇲🇾 Malaysia',
    maldives: '🇲🇻 Maldives',
    mali: '🇲🇱 Mali',
    malta: '🇲🇹 Malta',
    marshall_islands: '🇲🇭 Marshall Islands',
    martinique: '🇲🇶 Martinique',
    mauritania: '🇲🇷 Mauritania',
    mauritius: '🇲🇺 Mauritius',
    mayotte: '🇾🇹 Mayotte',
    mexico: '🇲🇽 Mexico',
    micronesia_federated: '🇫🇲 Micronesia, Federated States of',
    moldova_republic: '🇲🇩 Moldova, Republic of',
    monaco: '🇲🇨 Monaco',
    mongolia: '🇲🇳 Mongolia',
    montenegro: '🇲🇪 Montenegro',
    montserrat: '🇲🇸 Montserrat',
    morocco: '🇲🇦 Morocco',
    mozambique: '🇲🇿 Mozambique',
    myanmar: '🇲🇲 Myanmar',
    namibia: '🇳🇦 Namibia',
    nauru: '🇳🇷 Nauru',
    nepal: '🇳🇵 Nepal',
    netherlands: '🇳🇱 Netherlands',
    netherlands_antilles: '🇦🇳 Netherlands Antilles',
    new_caledonia: '🇳🇨 New Caledonia',
    new_zealand: '🇳🇿 New Zealand',
    nicaragua: '🇳🇮 Nicaragua',
    niger: '🇳🇪 Niger',
    nigeria: '🇳🇬 Nigeria',
    niue: '🇳🇺 Niue',
    norfolk_island: '🇳🇫 Norfolk Island',
    northern_mariana: '🇲🇵 Northern Mariana Islands',
    norway: '🇳🇴 Norway',
    oman: '🇴🇲 Oman',
    pakistan: '🇵🇰 Pakistan',
    palau: '🇵🇼 Palau',
    palestinian_territory: '🇵🇸 Palestinian Territory, Occupied',
    panama: '🇵🇦 Panama',
    papua_new: '🇵🇬 Papua New Guinea',
    paraguay: '🇵🇾 Paraguay',
    peru: '🇵🇪 Peru',
    philippines: '🇵🇭 Philippines',
    pitcairn: '🇵🇳 Pitcairn',
    poland: '🇵🇱 Poland',
    portugal: '🇵🇹 Portugal',
    puerto_rico: '🇵🇷 Puerto Rico',
    qatar: '🇶🇦 Qatar',
    reunion: '🇷🇪 Reunion',
    romania: '🇷🇴 Romania',
    russian_federation: '🇷🇺 Russian Federation',
    rwanda: '🇷🇼 Rwanda',
    saint_barthelemy: '🇧🇱 Saint Barthelemy',
    saint_helena: '🇸🇭 Saint Helena',
    saint_kitts: '🇰🇳 Saint Kitts and Nevis',
    saint_lucia: '🇱🇨 Saint Lucia',
    saint_martin: '🇲🇫 Saint Martin',
    saint_pierre: '🇵🇲 Saint Pierre and Miquelon',
    saint_vincent: '🇻🇨 Saint Vincent and the Grenadines',
    samoa: '🇼🇸 Samoa',
    san_marino: '🇸🇲 San Marino',
    sao_tome: '🇸🇹 Sao Tome and Principe',
    saudi_arabia: '🇸🇦 Saudi Arabia',
    senegal: '🇸🇳 Senegal',
    serbia: '🇷🇸 Serbia',
    serbia_montenegro: '🇨🇸 Serbia and Montenegro',
    seychelles: '🇸🇨 Seychelles',
    sierra_leone: '🇸🇱 Sierra Leone',
    singapore: '🇸🇬 Singapore',
    sint_maarten: '🇸🇽 Sint Maarten',
    slovakia: '🇸🇰 Slovakia',
    slovenia: '🇸🇮 Slovenia',
    solomon_islands: '🇸🇧 Solomon Islands',
    somalia: '🇸🇴 Somalia',
    south_africa: '🇿🇦 South Africa',
    south_georgia: '🇬🇸 South Georgia and the South Sandwich Islands',
    south_sudan: '🇸🇸 South Sudan',
    spain: '🇪🇸 Spain',
    sri_lanka: '🇱🇰 Sri Lanka',
    sudan: '🇸🇩 Sudan',
    suriname: '🇸🇷 Suriname',
    svalbard_jan: '🇸🇯 Svalbard and Jan Mayen',
    swaziland: '🇸🇿 Swaziland',
    sweden: '🇸🇪 Sweden',
    switzerland: '🇨🇭 Switzerland',
    syrian_arab: '🇸🇾 Syrian Arab Republic',
    taiwan_province: '🇹🇼 Taiwan, Province of China',
    tajikistan: '🇹🇯 Tajikistan',
    tanzania_united: '🇹🇿 Tanzania, United Republic of',
    thailand: '🇹🇭 Thailand',
    timor_leste: '🇹🇱 Timor-Leste',
    togo: '🇹🇬 Togo',
    tokelau: '🇹🇰 Tokelau',
    tonga: '🇹🇴 Tonga',
    trinidad_tobago: '🇹🇹 Trinidad and Tobago',
    tunisia: '🇹🇳 Tunisia',
    turkey: '🇹🇷 Turkey',
    turkmenistan: '🇹🇲 Turkmenistan',
    turks_caicos: '🇹🇨 Turks and Caicos Islands',
    tuvalu: '🇹🇻 Tuvalu',
    uganda: '🇺🇬 Uganda',
    ukraine: '🇺🇦 Ukraine',
    united_arab: '🇦🇪 United Arab Emirates',
    united_kingdom: '🇬🇧 United Kingdom',
    united_states: '🇺🇸 United States',
    unitedStates_minor: '🇺🇲 United States Minor Outlying Islands',
    uruguay: '🇺🇾 Uruguay',
    uzbekistan: '🇺🇿 Uzbekistan',
    vanuatu: '🇻🇺 Vanuatu',
    venezuela: '🇻🇪 Venezuela',
    viet_nam: '🇻🇳 Viet Nam',
    virgin_islands: '🇻🇬 Virgin Islands, British',
    islands_us: '🇻🇮 Virgin Islands, U.s.',
    wallis_futuna: '🇼🇫 Wallis and Futuna',
    western_sahara: '🇪🇭 Western Sahara',
    yemen: '🇾🇪 Yemen',
    zambia: '🇿🇲 Zambia',
    zimbabwe: '🇿🇼 Zimbabwe',
  },

  create_code: 'Create Code',
  create_newCode: 'Create a new Code',

  miscellaneous: {
    tweel_url: 'Add Tweet URL',
    divider: 'Divider',
    add_share: 'Add a Share Block',
    add_countdown: 'Add a Countdown Timer',
    date_time: 'Date & Time',
    add_action: 'Add an Action',
    add_faq: 'Add FAQs',
    email_me: 'Email me',

    discount_plan: 'Choose a discount between 1% and 99% off for the code',
    bulk_generator: 'Bulk Generator',
  },

  edit_taxes: {
    create_new: 'Create a new tax',
    created_tax:
      'Once a tax is created, it canot be edited or deleted. After the tax is created, you can associate it with your created Plans.',
    percentage: 'Percentage',
    taxes: 'Taxes',
    edittax: 'Edit tax',
    edit: 'Edit',
    description: 'Description',
    tax_value: 'Tax value',
    value_type: 'Value Type',
    fixed: 'Fixed',
    inclusive: 'Inclusive',
    exclusive: 'Exclusive',
    personal_only: 'Personal only',
    business_only: 'Business only',
    personal_business: 'Personal & Business',
    billing_for: 'Billing for',
    countries: 'Countries',

    select:
      'Select the countries that you want to apply this tax on. Leave empty if you want the tax to be applied for all countries.',
  },

  planss: {
    edit_plan: ' Edit Plan',
    plan_features: 'Plan Features',
    set: ' Set',
    for_unlimited: 'for unlimited',
    total_amoutpage: 'The total amount of biolink pages that a user can create.',
    total_shortlink: 'The total amount of shortened links that a user can create.',
    total_filelink: 'The total amount of file links that a user can create.',
    vcard_Limit: 'Vcard links Limit',
    totl_vcard: ' The total amount of vcard links that a user can create.',
    total_eventlinks: 'The total amount of event links that a user can create.',
    total_domain: 'The total amount of custom domains that a user can add. ',
    link_state: '  How many days will the links statistics be kept in the database.',
    enable_blocks: 'Enabled Biolink Blocks',
    select_blocks: 'Select which biolink page blocks are enabled for usage on this plan.',
    state_retention: 'Links statistics retention (days)',
    custom_domain: 'Custom Domains Limit',
    event_limit: 'Events links Limit',
    file_limit: 'File links Limit',
    link_limit: 'Links Limit',
    blocks_limit: 'Biolink blocks per biolink page limit',
    biolink_limit: 'Biolinks Limits',
    qr_limit: 'QR Codes Limits',
    pixels_limits: 'Pixels Limits',
    project_limits: 'Project Limits',
    additional_block: 'Additional Global Domains',
    additional_blockDes:
      'Enabling this will make all people having this plan be able to use all the additional global domains.',
    back_half: 'Custom back-half',
    back_halfDes:
      'Enabling this will give the ability for users to have custom URL aliases instead of auto-generated ones.',
    deep_link: 'Deep links',
    deep_linkDes:
      'Enabling this will give the ability to the user to use deep links to point to specific apps instead of only http and https urls.',
    enable_ad: 'Enabling this will make all people having this plan to not see any ads',
    remove_brand: 'Removable Footer Branding',
    remove_brandDes: 'This gives the option for people to remove branding from the biolinks footer.',
    button_url: 'Contact Button URL',
    description: 'Description',
    phone_collector: 'Phone collector',
    email_collector: 'Email collector',
    paragraph: 'Paragraph',
    custom_branding: 'Custom Footer Branding',
    custom_brandingDes: 'This gives the option for people to add their custom branding for the biolinks footer.',
    colored_links: 'Colored Links',
    colored_linksDes: 'Gives the user the ability to customize the color of their biolinks links',
    advanced_statistics: 'Advanced Statistics',
    check_stat: 'Gives the user the ability to check more in depth statistics and select the time frame',
    custom_backgrounds: 'Custom Backgrounds',
    custom_backgroundDes:
      'Gives the user the ability to add custom backgrounds on their biolinks pages ( colors, gradients and actual images ).',
    temporary_URL: 'Temporary URL',
    temporary_urlDes: 'Gives the user the ability to schedule links & limit clicks.',
    seo_des: 'Gives the user the ability to change the Title and Meta Description of Biolink pages',
    utm_des: 'Gives the user the ability to set global UTM parameters for all the links inside of a Biolink page.',
    fonts_des: 'Gives the user the ability to pick a font of his liking from the list of extra fonts.',
    password_protection: 'Password protection',
    password_protectionDes: 'Gives the user the ability to password protect their links.',
    sensitive_content: 'Sensitive content warning',
    sensitive_contentDes: 'Gives the user the ability to enable a sensitive content warning on their links.',
    leap_linkDes: 'Gives the user the ability to temporarily redirect biolink pages to a particular URL.',
    dofollow_link: 'Dofollow biolink links',
    dofollow_linkDes:
      'The user biolink links will have the dofollow property, otherwise it is set to nofollow by default.',
    rest_api: 'Enable ability for the user to use the REST API.',
    customcss_des:
      'Enable ability to add custom css for each biolink page. Be aware to only allow trusted people to use this feature.',
    customjs_des:
      'Enable ability to add custom js for each vcard. Be aware to only allow trusted people to use this feature.',
    product_name: 'Product Name',
    order: 'Order',
    plan_name: 'Plan Name',
    action: 'Action',
  },

  filtermodal: {
    all: 'All',
    unconfirmed: 'Unconfirmed',
    admin_created: 'Admin created',
    admin_api: 'Admin API created',
    facebook_login: 'Facebook login',
    twitter_login: 'Twitter login',
    discord_login: 'Discord login',
    google_login: 'Google login',
    registration_date: 'Registration date',
    ascending: 'Ascending',
    descending: 'Descending',
    ten: '2',
    twentyfive: '3',
    fifty: '5',
    hundred: '7',
    twohundred: '10',
    fivehundred: '20',
    filters: 'Filters',
    order_by: 'Order by',
    results_page: 'Results per page',
    created_datetime: 'Created datetime',
    redeemable: 'Redeemable',
    dayss: 'Days',
    external_payment: 'External Payment ID',
    paid: 'Paid',
    pending: 'Pending',
    offline_payment: 'Offline payment',
    coinbase: 'Coinbase',
    payU: 'PayU',
    paystack: 'Paystack',
    razorpay: 'Razorpay',
    mollie: 'Mollie',
    yookassa: 'Yookassa',
    crypto: 'Crypto.com',
    paddle: 'Paddle',
    monthly_payments: 'Monthly Payments',
    missing_translation: 'missing_translation: admin_payments.filters.order_by_name',
    missing_translate: 'missing_translation: admin_payments.filters.order_by_email',
  },
};

export default en;
